import styled from 'styled-components';
import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import { Button } from '@spotnana/pixel-react/dist/Button';
import Typography from '@spotnana/pixel-react/dist/Typography';
import { css } from '@emotion/react';
import { breakpoints } from '@spotnana/blocks/src/utils';

export const container = css`
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  ${breakpoints.from('tablet')} {
    margin-bottom: 24px;
  }
`;

export const TitleContainer = styled(Flex)`
  align-items: center;
`;

export const Icon = styled(Flex)`
  height: 40px;
  width: 40px;
  border-radius: 8px;
  margin-right: 24px;
  background-color: ${({ theme }) => theme.colors.surface};
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  & svg {
    height: 24px;
    width: 24px;
    fill: ${({ theme }): string => theme.colors.text.semiBold};
  }
`;

export const TitleSubtitleContainer = styled(Box)``;

export const Title = styled(Box)`
  font-weight: 600;
  font-size: 24px;
  color: ${({ theme }): string => theme.colors.text.semiBold};
`;

export const SubTitle = styled(Typography).attrs({ variation: 'label', color: 'text.label' })`
  margin-top: 8px;
`;

export const ActionButton = styled(Button).attrs({
  variation: 'tertiary',
})`
  border: none;
  margin-right: -8px;
`;
